// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 476) return "static/css/476.21fee3c4c8ad7b27eb4c.lib.css";
	if (chunkId === 678) return "static/css/678.561c96bb87fcb6272388.css";
	// return url for filenames based on template
	return undefined;
};